<template>
    <div class="box">
        <div class="imgUrl" v-if="urlList.length>0">
            <img v-for="(item,index) in urlList" :key="index" style="width: 100%;" :src="`${imgUrl}/${item}`" alt="">
        </div>
        <div v-else>
            <el-empty :image-size="200"></el-empty>
        </div>
    </div>
</template>

<script>
export default {
    name: 'homePageDetails',
    data() {
        return {
            urlList: "",
            imgUrl:"",

        }
    },
    methods: {
        openBox(val) {
            if (val) {
                this.imgUrl = window.global_config.BASE_IMG_URL
                this.urlList=val.contentUrl.split(',')
            }
        },
    },
}
</script>

<style scoped>
.box {
    width: 100%;
    height: 100%;
    background-color: rgb(248, 248, 248);
    overflow: auto;
    display: flex;
    justify-content: center;
    padding-top: 10px;
}
.imgUrl {
    width: 1000px;
    font-size: 0;
}
</style>